export const LEADS_PAGE_SIZE = 100;
